import React from "react";
import PredefinedIcon, {
    PredefinedIconType,
} from "../../icons/Icon/Predefined";
import useStore from "../ContactForm/store";
import classNames from "classnames";
import {
    LinkItemClickable,
    StyledIconContainer,
} from "../Desktop/TopRow/TopLinkItems";

const Contact = ({}) => {
    const { contactFormVisible, toggleContactForm } = useStore(
        ({ contactFormVisible, toggleContactForm }) => ({
            contactFormVisible,
            toggleContactForm,
        })
    );

    const contactFormName = "Kontakt";

    return (
        <LinkItemClickable
            onClick={toggleContactForm}
            className={classNames({ active: contactFormVisible })}
        >
            <StyledIconContainer>
                <PredefinedIcon type={PredefinedIconType.text} />
            </StyledIconContainer>
            <span>{contactFormName}</span>
        </LinkItemClickable>
    );
};

export default Contact;
